module.exports = __webpack_public_path__ + "static/7-karoake-56b657c5780b0173ca83abf9234b914a.jpg";